import React, { useState } from 'react';
import data from '../data/portfolio.json';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { useGSAP } from "@gsap/react";

// Register required GSAP plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export function Getdata() {
  // --------------------------------------------------
  // STATE MANAGEMENT
  // --------------------------------------------------
  const [scrollPosition, setScrollPosition] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(() => {
    return sessionStorage.getItem('portCat') || 'All';
  });

  // Filter and sort portfolio data
  const filteredData = data
    .filter(item => selectedCategory === 'All' ? true : item.design_category === selectedCategory)
    .sort((a, b) => b.design_id - a.design_id);

  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    setSelectedCategory(newCategory);
    sessionStorage.setItem('portCat', newCategory);

     //<<<<<<<<<<<<<<<<<<<<<<< =========================================================== LAST HERE
      
    //ThumbScrollFX();
  

  };


// end of 















// ===========================
// THUMBNAIL REVEAL SCRIPT
// ===========================

function ThumbScrollFX() {

  gsap.set(".thumbnail-frame", { opacity: 0, rotationY: 20, rotationX: -30, perspective: 400 });
  gsap.set(".thumbnail-heading", { opacity: 0 });
  
  let thumb = document.querySelectorAll('.thumbnail');  
  
  ScrollTrigger.batch(thumb, {
    start: 'top 85%',
    once: true,
    onEnter: (batch) => {
      // Extract all frames and headings for the cards currently entering the viewport together
      const frames = batch.map(section => section.querySelector('.thumbnail-frame'));
      const headings = batch.map(section => section.querySelector('.thumbnail-heading'));

      let tl_folder = gsap.timeline();

      // NOW stagger works because 'frames' is an ARRAY of all visible cards!
      tl_folder.to(frames, {
        duration: 1.2, 
        opacity: 1, 
        rotationY: 0, 
        rotationX: 0, 
        transformOrigin: "center center",  
        ease: "power2.out",
        stagger: 0.15 
      })
      .to(headings, { 
        duration: 0.5, 
        opacity: 1,
        stagger: 0.15 
      }, "<+=0.2"); // Starts heading fade slightly after frame starts
    }
  });

  // 3. FORCE GSAP TO RE-CALCULATE SCROLL POSITIONS
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 100);
  
} // EOF - thumbScrollFX() 

//ThumbScrollFX();


// --------------------------------------------------
  // GSAP TRIGGER ON CATEGORY CHANGE - FILTER
  // --------------------------------------------------
  
  useGSAP(() => {

   gsap.set(".thumbnail-frame", { opacity: 0, rotationY: 20, rotationX: -30, perspective: 400 });
  gsap.set(".thumbnail-heading", { opacity: 0 });

   let thumb = document.querySelectorAll('.thumbnail');  
ScrollTrigger.batch(thumb, {
    start: 'top 85%',
    once: true,
    onEnter: (batch) => {
      // Extract all frames and headings for the cards currently entering the viewport together
      const frames = batch.map(section => section.querySelector('.thumbnail-frame'));
      const headings = batch.map(section => section.querySelector('.thumbnail-heading'));

      let tl_folder = gsap.timeline();

      // NOW stagger works because 'frames' is an ARRAY of all visible cards!
      tl_folder.to(frames, {
        duration: 1.2, 
        opacity: 1, 
        rotationY: 0, 
        rotationX: 0, 
        transformOrigin: "center center",  
        ease: "power2.out",
        stagger: 0.15 // <--- Staggers items 0.15s apart as a group
      })
      .to(headings, { 
        duration: 0.5, 
        opacity: 1,
        stagger: 0.15 
      }, "<+=0.2"); // Starts heading fade slightly after frame starts
    }
  });
  }, [selectedCategory]);



  // --------------------------------------------------
  // AUTOSCROLL BACK TO POSITION
  // --------------------------------------------------
useGSAP(() => {
  // Auto Scroll Restoration
  const savedPosition = sessionStorage.getItem('scrollPos');

  const handleScroll = () => {
    const currentPosition = window.scrollY;
    sessionStorage.setItem('scrollPos', currentPosition);
  };

  if (savedPosition) {
    gsap.to(window, { 
      scrollTo: parseFloat(savedPosition), 
      duration: 1,
      delay: 1.5,
      onComplete: () => {
        window.addEventListener('scroll', handleScroll, { passive: true });
      }
    });
  } else {
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  return () => window.removeEventListener('scroll', handleScroll);
}, []);




  // --------------------------------------------------
  // RENDER
  // --------------------------------------------------
  return (
    <div className="gallery">
      <div className="portfolio-filter">
        <strong>Filter By Design Category</strong>
        <select value={selectedCategory} onChange={handleCategoryChange}>
          <option value="All">Show all Designs</option>
          <option value="Graphic Design">Graphic Design</option>
          <option value="Web Development">Web Development</option>
        </select>
      </div>

      <div className="thumbnail-wrap">
        {filteredData.map(folder => (
          <Link 
            className="thumbnail" 
            to={`/portfolio/${folder.design_slug + '-id-' + folder.design_id}`} 
            key={folder.design_id} 
            data-port-id={folder.design_id} 
          > 
            <div className="thumbnail-frame">
              <div className="thumbnail-image">
                <img src={folder.design_thumbnail} alt={folder.design_type + " id " + folder.design_id} loading="lazy" />
              </div>
              <div className="border-fx-top"></div>
              <div className="border-fx-right"></div>
              <div className="border-fx-bottom"></div>
              <div className="border-fx-left"></div>
            </div>
            <div className="thumbnail-heading">{folder.design_type}</div>
          </Link> 
        ))}     
      </div>
    </div>
  );
}